const record = {
  path: 'record',
  component: resolve => require(['@/pages/admin/recharge/record'], resolve)
}

export default record
